import styled from 'styled-components';
import { designTokens } from '../foundation/DesignTokens';

// Main content container
export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${designTokens.spacing.lg};

  @media (max-width: 900px) {
    padding: 0 ${designTokens.spacing.md};
  }

  @media (max-width: 600px) {
    padding: 0 ${designTokens.spacing.sm};
  }
`;

// Card container for content sections
export const Card = styled.div`
  background: white;
  border: 1px solid ${designTokens.colors.gray[200]};
  border-radius: ${designTokens.radius.lg};
  box-shadow: ${designTokens.shadows.sm};
  margin-bottom: ${designTokens.spacing.lg};

  @media (max-width: 900px) {
    padding: ${designTokens.spacing.lg};
    margin-bottom: ${designTokens.spacing.md};
    border-radius: ${designTokens.radius.md};
  }

  @media (max-width: 600px) {
    padding: ${designTokens.spacing.md};
    border-radius: ${designTokens.radius.sm};
  }
`;

// Section container for grouping related content
export const Section = styled.section`
  margin-bottom: ${designTokens.spacing['2xl']};

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 900px) {
    margin-bottom: ${designTokens.spacing.xl};
  }
`;

// Header for sections
export const SectionHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: ${designTokens.spacing.lg};

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${designTokens.spacing.sm};
  }
`;

// Section title
export const SectionTitle = styled.h2`
  font-family: ${designTokens.fonts.heading};
  font-weight: 800;
  font-size: 1.25rem;
  color: ${designTokens.colors.gray[900]};
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${designTokens.spacing.sm};

  @media (max-width: 900px) {
    font-size: 1.1rem;
  }
`;

// Section description
export const SectionDescription = styled.p`
  font-size: 0.9rem;
  color: ${designTokens.colors.gray[500]};
  max-width: 620px;
  margin: ${designTokens.spacing.sm} 0 0 0;
  line-height: 1.5;

  @media (max-width: 900px) {
    font-size: 0.85rem;
  }
`;

// Flex container for layout
export const FlexContainer = styled.div`
  display: flex;
  gap: ${designTokens.spacing.lg};
  align-items: ${(props) => props.align || 'flex-start'};
  justify-content: ${(props) => props.justify || 'flex-start'};
  flex-wrap: ${(props) => props.wrap || 'nowrap'};

  @media (max-width: 900px) {
    flex-direction: ${(props) => props.mobileDirection || 'column'};
    gap: ${designTokens.spacing.md};
  }
`;

// Grid container for layout
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.columns || 'repeat(auto-fit, minmax(300px, 1fr))'};
  gap: ${designTokens.spacing.lg};

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: ${designTokens.spacing.md};
  }
`;

export default Container;
